import { IonButton, IonModal } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { ActionType, MailType } from "../models/Enums";
import React, { useEffect, useState } from "react";
import {
  PatientState,
  dummyDropDowns,
  isShowToast,
  newAllDropDownState,
} from "../data/atoms";
import { useRecoilState } from "recoil";
import {
  ForgotPasswordAuth,
  GetPatientById,
  LogOut,
} from "../services/AuthServices";
import { PatientVM } from "../models/PatientVM";
import PatientExistModal from "../components/modals/patient-exist-modal";
import { utcToLocalDate } from "../utils/sharedFunction";

interface Props {
  actionType: any;
}

const SuccessFailed: React.FC<Props> = ({ actionType }) => {
  console.log("actiontype: ", actionType);

  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  const [isDisabled, setIsDisabled] = useState(false);
  const [patientNotExistModal, setPatientNotExistModal] = useState(false);

  let history = useHistory();
  if (actionType?.actionType) {
    actionType = actionType?.actionType;
  }

  useEffect(() => {
    return () => {
      actionType = undefined;
    };
  }, [actionType]);

  async function GetPatientDetails() {
    try {
      await GetPatientById({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      }).then(async function (response) {
        if (
          response!.data.responseCode !== 0 &&
          Number(response?.data?.patientVM?.id) === -1
        ) {
          setPatientNotExistModal(true);
          return;
        }
        if (response!.data.responseCode !== 0) {
          // if (response?.data?.patientVM) {
          //   response.data.patientVM.rtmStartDate = utcToLocalDate(
          //     response.data.patientVM.rtmStartDate,
          //   );
          // }

          localStorage.setItem(
            "patientServerID",
            response?.data?.patientVM?.id,
          );

          setNewAllDropDown(dummyDropDowns);

          setpatientInfo((prevState: PatientVM) => ({
            ...prevState,
            ...response!.data.patientVM,
            referralId: response!.data.patientVM.referralSourceId,
          }));

          localStorage.setItem(
            "fullName",
            response!.data.firstName + " " + response!.data.lastName,
          );

          history.push("/patient-page", { props: true });
        } else {
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function clearAndRedirect() {
    await LogOut();
    let getAssessmentHisotory = JSON.parse(
      localStorage.getItem("summaryDetail") || "[]",
    );
    let userEmail = JSON.parse(
      localStorage.getItem("loggedInUserName") || "[]",
    );
    localStorage.clear();
    localStorage.setItem(
      "summaryDetail",
      JSON.stringify(getAssessmentHisotory!),
    );
    localStorage.setItem(
      "loggedInUserName",
      JSON.stringify({ email: userEmail.email! }),
    );
    window.location.href = window.location.origin + "/login";
  }

  async function ResetPassword(email: string) {
    try {
      await ForgotPasswordAuth({
        Email: email,
        MailType: MailType.ResetCodeEmail,
      })
        .then(function (response: any) {
          debugger;
          setIsDisabled(false);
          if (response!.data.responseCode === 1) {
            localStorage.setItem("UserID", response!.data.id);
            localStorage.setItem("TokenID", response!.data.token);
            localStorage.setItem("LocationId", response!.data.locationId);
            localStorage.setItem("WorkstationId", response!.data.workstationId);
            localStorage.setItem("resetEmail", email);
            localStorage.setItem("Username", response!.data.responseMessage);
            localStorage.setItem(
              "EncryptedServerId",
              response!.data.encryptedServerId,
            );
            localStorage.setItem("BusinessType", response!.data.businessType);
            history.replace("/code", {
              actionType: ActionType.ForgotPassword,
            });
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  return (
    <div className="overall-center-modal slide-in-bottom">
      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={patientNotExistModal}
        placeholder={undefined}
      >
        <PatientExistModal
          setShowModal1={setPatientNotExistModal}
          actionType={ActionType.PatientDoesNotExist}
        ></PatientExistModal>
      </IonModal>

      <div className="generic-modal-main-wrap">
        <div className="icon-sec text-center">
          {actionType == ActionType.UserDoesNotExist && (
            <svg
              width="163"
              height="130"
              viewBox="0 0 163 130"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M113.748 32.4993C113.748 47.5302 103.566 60.1745 89.7032 63.8814L48.749 31.7884C49.1298 14.1677 63.526 0 81.2483 0C99.199 0 113.748 14.5485 113.748 32.4993ZM67.106 77.262L133.374 129.464C132.511 129.819 131.571 129.997 130.581 129.997H31.9154C27.7514 129.997 24.3745 126.62 24.3745 122.456C24.3745 98.3103 43.2901 78.5569 67.106 77.262Z"
                fill="black"
              />
              <path
                d="M1.29632 2.33731C3.37831 -0.303253 7.21221 -0.785665 9.85277 1.29632L160.162 119.106C162.803 121.188 163.285 125.022 161.203 127.663C159.121 130.303 155.287 130.786 152.647 128.704L2.33731 10.8938C-0.303253 8.81178 -0.785665 4.97788 1.29632 2.33731Z"
                fill="#802392"
              />
            </svg>
          )}

          {/* Success SVG */}
          {(actionType === ActionType.SuccessCreatePatient ||
            actionType === ActionType.SuccessPasswordReset ||
            actionType === ActionType.NewUser ||
            actionType === ActionType.SuccessUpdatePatient ||
            actionType === ActionType.SuccessUpdateUser) && (
            <svg
              width="145"
              height="146"
              viewBox="0 0 145 146"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M72.5 138C108.399 138 137.5 108.899 137.5 73C137.5 37.1015 108.399 8 72.5 8C36.6015 8 7.5 37.1015 7.5 73C7.5 108.899 36.6015 138 72.5 138Z"
                fill="#0F854C"
                stroke="#0F854C"
                strokeWidth="14.4444"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M94.1668 58.5557L65.2779 87.4446L50.8335 73.0001"
                stroke="white"
                strokeWidth="14.4444"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          {/* Success SVG */}

          {actionType == ActionType.FailureAPIResponse && (
            <svg
              width="145"
              height="146"
              viewBox="0 0 145 146"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.277832 73.0005C0.277832 33.1133 32.6128 0.77832 72.5001 0.77832C112.387 0.77832 144.722 33.1133 144.722 73.0005C144.722 112.888 112.387 145.223 72.5001 145.223C32.6128 145.223 0.277832 112.888 0.277832 73.0005ZM55.9403 46.227C53.1198 43.4065 48.547 43.4065 45.7265 46.227C42.9061 49.0474 42.9061 53.6203 45.7265 56.4408L62.2862 73.0005L45.7265 89.5602C42.9061 92.3806 42.9061 96.9535 45.7265 99.7739C48.547 102.594 53.1198 102.594 55.9403 99.7739L72.5 83.2142L89.0594 99.7737C91.8799 102.594 96.4527 102.594 99.2732 99.7737C102.094 96.9532 102.094 92.3804 99.2732 89.5599L82.7137 73.0005L99.2734 56.4408C102.094 53.6203 102.094 49.0474 99.2734 46.227C96.453 43.4065 91.8801 43.4065 89.0597 46.227L72.5 62.7867L55.9403 46.227Z"
                fill="#890029"
              />
            </svg>
          )}

          {/* Error Avatar SVG */}
          {(actionType == ActionType.PatientAlreadyExist ||
            //actionType == ActionType.UserDeactivated ||
            actionType == ActionType.EmailAlreadyExist) && (
            <svg
              width="90"
              height="102"
              viewBox="0 0 90 102"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M45.1245 51C51.8875 51 58.3736 48.3134 63.1557 43.5312C67.9379 38.749 70.6245 32.263 70.6245 25.5C70.6245 18.737 67.9379 12.251 63.1557 7.46878C58.3736 2.6866 51.8875 0 45.1245 0C38.3615 0 31.8755 2.6866 27.0933 7.46878C22.3111 12.251 19.6245 18.737 19.6245 25.5C19.6245 32.263 22.3111 38.749 27.0933 43.5312C31.8755 48.3134 38.3615 51 45.1245 51ZM36.0202 60.5625C16.3972 60.5625 0.499512 76.4602 0.499512 96.0832C0.499512 99.3504 3.14912 102 6.41631 102H83.8327C87.0999 102 89.7495 99.3504 89.7495 96.0832C89.7495 76.4602 73.8519 60.5625 54.2288 60.5625H36.0202Z"
                fill="#802392"
              />
            </svg>
          )}
          {/* Error Avatar SVG */}

          {/* Deactivated SVG */}
          {actionType === ActionType.UserDeactivated && (
            <div>
              <svg
                width="100"
                height="129"
                viewBox="0 0 100 129"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M56.4375 0C64.9907 0 73.1936 3.39776 79.2417 9.44581C85.2897 15.4939 88.6875 23.6968 88.6875 32.25C88.6875 40.8032 85.2897 49.0061 79.2417 55.0542C73.1936 61.1022 64.9907 64.5 56.4375 64.5C47.8843 64.5 39.6814 61.1022 33.6333 55.0542C27.5853 49.0061 24.1875 40.8032 24.1875 32.25C24.1875 23.6968 27.5853 15.4939 33.6333 9.44581C39.6814 3.39776 47.8843 0 56.4375 0ZM44.9232 76.5938H67.9518C73.142 76.5938 78.1307 77.4756 82.7666 79.0881C81.3809 83.3965 80.625 87.9568 80.625 92.7188C80.625 107.71 88.0576 120.963 99.4711 129H7.48301C3.35098 129 0 125.649 0 121.517C0 96.6996 20.1059 76.5938 44.9232 76.5938Z"
                  fill="#898989"
                />
              </svg>
              <svg
                width="74"
                height="74"
                viewBox="0 0 74 74"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.333496 37.0007C0.333496 16.7502 16.7497 0.333984 37.0002 0.333984C57.2506 0.333984 73.6668 16.7502 73.6668 37.0007C73.6668 57.2511 57.2506 73.6673 37.0002 73.6673C16.7497 73.6673 0.333496 57.2511 0.333496 37.0007ZM28.5929 23.4079C27.161 21.976 24.8394 21.976 23.4074 23.4079C21.9755 24.8398 21.9755 27.1615 23.4074 28.5934L31.8147 37.0006L23.4074 45.4078C21.9755 46.8398 21.9755 49.1614 23.4074 50.5933C24.8394 52.0252 27.161 52.0252 28.5929 50.5933L37.0001 42.1861L45.4072 50.5932C46.8392 52.0251 49.1608 52.0251 50.5927 50.5932C52.0246 49.1612 52.0246 46.8396 50.5927 45.4077L42.1856 37.0006L50.5928 28.5934C52.0247 27.1615 52.0247 24.8398 50.5928 23.4079C49.1609 21.976 46.8393 21.976 45.4074 23.4079L37.0001 31.8152L28.5929 23.4079Z"
                  fill="#802392"
                />
              </svg>
            </div>
          )}
          {/* Deactivated SVG */}

          {/* Exit SVG */}
          {(actionType === ActionType.ExitUserSetup ||
            actionType === ActionType.ExitUserSetupFromCode ||
            actionType === ActionType.ExitUserSetupFromSignup ||
            actionType === ActionType.ExitUserSetupFromSignupPassword ||
            actionType === ActionType.ExitPatientSetup ||
            actionType === ActionType.Logout ||
            actionType === ActionType.EditUserProfile) && (
            <svg
              width="103"
              height="103"
              viewBox="0 0 103 103"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.4783 30.4158C49.6994 28.1947 53.3006 28.1947 55.5217 30.4158L72.5842 47.4783C73.6508 48.5449 74.25 49.9916 74.25 51.5C74.25 53.0084 73.6508 54.4551 72.5842 55.5217L55.5217 72.5842C53.3006 74.8053 49.6994 74.8053 47.4783 72.5842C45.2572 70.3631 45.2572 66.7619 47.4783 64.5408L54.8317 57.1875H6C2.85888 57.1875 0.3125 54.6411 0.3125 51.5C0.3125 48.3589 2.85888 45.8125 6 45.8125L54.8317 45.8125L47.4783 38.4592C45.2572 36.2381 45.2572 32.6369 47.4783 30.4158Z"
                fill="#802392"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.3125 11.6875C0.3125 5.40526 5.40526 0.3125 11.6875 0.3125H91.3125C97.5947 0.3125 102.688 5.40526 102.688 11.6875V91.3125C102.688 97.5947 97.5947 102.688 91.3125 102.688H11.6875C5.40526 102.688 0.3125 97.5947 0.3125 91.3125V79.9375C0.3125 76.7964 2.85888 74.25 6 74.25C9.14112 74.25 11.6875 76.7964 11.6875 79.9375V91.3125H91.3125V11.6875H11.6875V23.0625C11.6875 26.2036 9.14112 28.75 6 28.75C2.85888 28.75 0.3125 26.2036 0.3125 23.0625V11.6875Z"
                fill="#802392"
              />
            </svg>
          )}

          {/* Exit SVG */}

          {/* Expired Password */}
          {actionType === ActionType.ExpiredPassword && (
            <svg
              width="201"
              height="201"
              viewBox="0 0 201 201"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.1278 83.6112C39.8801 84.8253 39.75 86.0818 39.75 87.3682V143.618C39.75 153.96 48.1582 162.368 58.5 162.368H144.769L40.1278 83.6112ZM171 140.65V87.3682C171 77.0264 162.592 68.6182 152.25 68.6182H147.562V54.5557C147.562 31.2646 128.666 12.3682 105.375 12.3682C82.084 12.3682 63.1875 31.2646 63.1875 54.5557V59.5067L171 140.65ZM81.9375 68.6182V54.5557C81.9375 41.6064 92.4258 31.1182 105.375 31.1182C118.324 31.1182 128.812 41.6064 128.812 54.5557V68.6182H81.9375Z"
                fill="black"
              />
              <path
                d="M2.34548 32.2449C4.90793 28.9949 9.6266 28.4012 12.8765 30.9636L197.873 175.961C201.123 178.524 201.717 183.242 199.155 186.492C196.592 189.742 191.873 190.336 188.623 187.773L3.62671 42.7759C0.376763 40.2135 -0.216976 35.4948 2.34548 32.2449Z"
                fill="#802392"
              />
            </svg>
          )}
        </div>

        <div className="generic-modal-text">
          {/* Expired Password */}
          {actionType === ActionType.ExpiredPassword && (
            <>
              <h1>Expired Password</h1>
              <p>
                Your password has expired for security reasons. Please confirm
                your identity with the OTP sent to your registered email.
              </p>
            </>
          )}
          {/* Expired Password */}

          {(actionType === ActionType.SuccessCreatePatient ||
            actionType === ActionType.SuccessUpdateUser ||
            actionType === ActionType.SuccessUpdatePatient ||
            actionType === ActionType.NewUser ||
            actionType === ActionType.SuccessPasswordReset) && (
            <h1>Success!</h1>
          )}
          {/* Logout */}
          {actionType === ActionType.Logout && <h1>Logout</h1>}
          {/* Logout */}
          {/* Edit User Profile */}
          {actionType === ActionType.EditUserProfile && (
            <h1>Leave page without saving?</h1>
          )}
          {/* Edit User Profile */}
          {actionType === ActionType.ExitForgotPassword && (
            <h1>Forgot Password</h1>
          )}
          {actionType === ActionType.ExitExpiredPassword && (
            <h1>Reset Password</h1>
          )}
          {(actionType === ActionType.PatientAlreadyExist ||
            actionType === ActionType.UserDoesNotExist ||
            actionType === ActionType.UserDeactivated ||
            actionType === ActionType.EmailAlreadyExist) && <h1>Error</h1>}
          {(actionType === ActionType.ExitUserSetup ||
            actionType === ActionType.ExitUserSetupFromCode ||
            actionType === ActionType.ExitUserSetupFromSignup ||
            actionType === ActionType.ExitUserSetupFromSignupPassword) && (
            <h1>Are you sure you want to exit account setup?</h1>
          )}
          {(actionType === ActionType.ExitForgotPassword ||
            actionType === ActionType.ExitExpiredPassword) && (
            <>
              <p>Are you sure you want to exit?</p>
              <p>Any information you entered will be cleared.</p>
            </>
          )}
          {/* Logout */}
          {actionType === ActionType.Logout && (
            <p>Are you sure you want to logout?</p>
          )}
          {/* Logout */}
          {/* Edit User Profile */}
          {actionType === ActionType.EditUserProfile && (
            <p>Any changes you have made will be discarded.</p>
          )}
          {/* Edit User Profile */}
          {/* <h1>Timed Out</h1> */}
          {/* <h1>Are you sure you want to exit account setup?</h1> */}
          {actionType === ActionType.FailureAPIResponse && (
            <h1>Something went wrong.</h1>
          )}
          {actionType === ActionType.NewUser && (
            <p>
              Your Proactive Strides account has been setup. Press OK to return
              to the login page.
            </p>
          )}
          {actionType === ActionType.SuccessPasswordReset && (
            <p>Password has been reset!</p>
          )}
          {actionType === ActionType.ExitPatientSetup && (
            <h1>Are you sure you want to exit patient setup?</h1>
          )}
          {actionType === ActionType.UserDoesNotExist && (
            <p>No user on file with this username or password.</p>
          )}
          {actionType === ActionType.UserDeactivated && (
            <p>
              This user is deactivated. Ask your administrator to reactivate
              your account on VSTBalance
            </p>
          )}

          {actionType === ActionType.FailureAPIResponse && (
            <p>Something went wrong. Retry or return to the login page.</p>
          )}
          {(actionType === ActionType.ExitUserSetup ||
            actionType === ActionType.ExitUserSetupFromCode ||
            actionType === ActionType.ExitUserSetupFromSignup ||
            actionType === ActionType.ExitUserSetupFromSignupPassword) && (
            <p>Your information will not be saved.</p>
          )}

          {actionType === ActionType.PatientAlreadyExist && (
            <p>This patient already exists.</p>
          )}
          {actionType === ActionType.EmailAlreadyExist && (
            <p>This email already exists.</p>
          )}
          {(actionType === ActionType.SuccessCreatePatient ||
            actionType === ActionType.CreateNewPatient) && (
            <p>New Patient successfully created.</p>
          )}
          {actionType === ActionType.SuccessUpdatePatient && (
            <p>Patient successfully updated.</p>
          )}
          {actionType === ActionType.SuccessUpdateUser && (
            <p>Your profile has been updated.</p>
          )}
          {actionType === ActionType.ExitPatientSetup && (
            <p>Your information will not be saved.</p>
          )}
        </div>

        <div className="generic-modal-btn-wrap">
          {actionType === ActionType.SuccessUpdateUser && (
            <IonButton
              className="generic-btn"
              placeholder={undefined}
              onClick={() => {
                history.push("/user-profile");
              }}
            >
              Back to Profile
            </IonButton>
          )}
        </div>

        <div className="generic-modal-btn-wrap two-btns">
          <ul>
            {(actionType === ActionType.EmailAlreadyExist ||
              actionType === ActionType.PatientAlreadyExist ||
              actionType === ActionType.ExitPatientSetup ||
              actionType === ActionType.ExitForgotPassword ||
              actionType === ActionType.ExitExpiredPassword ||
              actionType === ActionType.ExitUserSetup ||
              actionType === ActionType.ExitUserSetupFromCode ||
              actionType === ActionType.ExitUserSetupFromSignup ||
              actionType === ActionType.ExitUserSetupFromSignupPassword) && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    if (actionType === ActionType.ExitUserSetup) {
                      history.push("/email", {
                        actionType: ActionType.NewUser,
                      });
                    } else if (
                      actionType === ActionType.ExitUserSetupFromCode
                    ) {
                      history.push("/code", {
                        actionType: ActionType.NewUser,
                      });
                    } else if (
                      actionType === ActionType.ExitUserSetupFromSignup
                    ) {
                      history.push("/signup");
                    } else if (
                      actionType === ActionType.ExitUserSetupFromSignupPassword
                    ) {
                      history.push("/signup-password", {
                        actionType: ActionType.ForgotPassword,
                      });
                    } else if (actionType === ActionType.ExitForgotPassword) {
                      history.replace("/email", {
                        actionType: ActionType.ForgotPassword,
                      });
                    } else if (actionType === ActionType.ExitExpiredPassword) {
                      history.goBack();
                    } else {
                      history.goBack();
                    }
                  }}
                >
                  {actionType === ActionType.ExitForgotPassword
                    ? "Cancel"
                    : "Back"}
                </IonButton>
              </li>
            )}

            {(actionType === ActionType.SuccessCreatePatient ||
              actionType === ActionType.SuccessUpdatePatient) && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    history.push("/home");
                  }}
                >
                  Back to Search
                </IonButton>
              </li>
            )}

            {(actionType === ActionType.SuccessCreatePatient ||
              actionType === ActionType.EmailAlreadyExist ||
              actionType === ActionType.PatientAlreadyExist ||
              actionType === ActionType.SuccessUpdatePatient) && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    GetPatientDetails();
                  }}
                >
                  View Patient
                </IonButton>
              </li>
            )}

            {actionType === ActionType.UserDoesNotExist && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    history.push("/email", {
                      actionType: ActionType.NewUser,
                    });
                  }}
                >
                  Setup Account
                </IonButton>
              </li>
            )}

            {actionType === ActionType.UserDoesNotExist && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={() => {
                    history.push("/login");
                  }}
                  placeholder={undefined}
                >
                  Retry
                </IonButton>
              </li>
            )}

            {actionType === ActionType.FailureAPIResponse && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  onClick={() => {
                    clearAndRedirect();
                  }}
                  placeholder={undefined}
                >
                  Back to Login
                </IonButton>
              </li>
            )}

            {/* Expired Password */}
            {actionType === ActionType.ExpiredPassword && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  onClick={() => {
                    history.push("/login");
                  }}
                  placeholder={undefined}
                >
                  Back
                </IonButton>
              </li>
            )}
            {/* Expired Password */}

            {/* Logout */}
            {actionType === ActionType.Logout && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  onClick={() => {
                    history.push("/user-profile");
                  }}
                  placeholder={undefined}
                >
                  Cancel
                </IonButton>
              </li>
            )}

            {actionType === ActionType.Logout && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={() => {
                    clearAndRedirect();
                  }}
                  placeholder={undefined}
                >
                  Logout
                </IonButton>
              </li>
            )}
            {/* Logout */}

            {/* Edit User Profile */}
            {actionType === ActionType.EditUserProfile && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  onClick={() => {
                    history.replace("/edit-user-profile");
                  }}
                  placeholder={undefined}
                >
                  Cancel
                </IonButton>
              </li>
            )}

            {actionType === ActionType.EditUserProfile && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={() => {
                    history.push("/home");
                  }}
                  placeholder={undefined}
                >
                  Leave
                </IonButton>
              </li>
            )}
            {/* Edit User Profile */}
            {actionType === ActionType.FailureAPIResponse && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={() => {
                    history.goBack();
                  }}
                  placeholder={undefined}
                >
                  Retry
                </IonButton>
              </li>
            )}

            {/* Expired Password */}
            {actionType === ActionType.ExpiredPassword && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={() => {
                    setIsDisabled(true);
                    localStorage.setItem("isOtpFlow", "true");
                    ResetPassword(localStorage.getItem("resetEmail")!);
                  }}
                  placeholder={undefined}
                  disabled={isDisabled}
                >
                  Send OTP
                </IonButton>
              </li>
            )}
            {/* Expired Password */}

            {(actionType === ActionType.ExitPatientSetup ||
              actionType === ActionType.ExitForgotPassword ||
              actionType === ActionType.ExitExpiredPassword ||
              actionType === ActionType.ExitUserSetup ||
              actionType === ActionType.ExitUserSetupFromCode ||
              actionType === ActionType.ExitUserSetupFromSignup ||
              actionType === ActionType.ExitUserSetupFromSignupPassword) && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    if (actionType === ActionType.ExitExpiredPassword) {
                      localStorage.setItem("isOtpFlow", "false");
                    }
                    actionType === ActionType.ExitPatientSetup
                      ? history.push("/home")
                      : history.replace("/login");
                  }}
                >
                  Exit
                </IonButton>
              </li>
            )}
          </ul>
        </div>
        <div className="generic-modal-btn-wrap single-btn">
          <ul>
            {actionType === ActionType.UserDeactivated && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  Close
                </IonButton>
              </li>
            )}
            {actionType === ActionType.NewUser && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    // const pages = document.getElementsByClassName("ion-page");
                    // let index = pages.length - 1;
                    // while (index >= 1) {
                    // 	pages[index].remove();
                    // 	index--;
                    // }
                    history.push("/login");
                  }}
                >
                  Ok
                </IonButton>
              </li>
            )}
            {actionType === ActionType.SuccessPasswordReset && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    // const pages = document.getElementsByClassName("ion-page");
                    // let index = pages.length - 1;
                    // while (index >= 1) {
                    // 	pages[index].remove();
                    // 	index--;
                    // }
                    history.push("/login");
                  }}
                >
                  Back to Login
                </IonButton>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SuccessFailed;
